export const DISTRIBUTOR_ACTION_TYPES = {
    GET_DISTRIBUTOR_SUCCESS: "GET_DISTRIBUTOR_SUCCESS",
};